import { render, staticRenderFns } from "./TheButton.vue?vue&type=template&id=4c32e32e&scoped=true"
import script from "./TheButton.vue?vue&type=script&lang=js"
export * from "./TheButton.vue?vue&type=script&lang=js"
import style0 from "./TheButton.vue?vue&type=style&index=0&id=4c32e32e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c32e32e",
  null
  
)

export default component.exports